import { render, staticRenderFns } from "./participantsDropdown.vue?vue&type=template&id=df0541be&scoped=true&"
import script from "./participantsDropdown.vue?vue&type=script&lang=js&"
export * from "./participantsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./participantsDropdown.vue?vue&type=style&index=0&id=df0541be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0541be",
  null
  
)

export default component.exports